import { SWRConfiguration } from "swr";

import { QueryParams, useAPI } from "./useAPI";
import { useSubmit, UseSubmitOptions } from "./useSubmit";
import { paths as appPaths } from "../generated-schemas/billing";
import { paths as sharedPaths } from "../generated-schemas/shared";
import {
  GetRequest,
  CombinedPaths,
  PostRequest,
  ExtractPostResponseData,
  ExtractPostRequestBody,
  FilterByFetchType,
  InferAPI,
  InferAPIOptions,
} from "../types";

type GetSchemas = CombinedPaths<
  FilterByFetchType<appPaths & sharedPaths, GetRequest>
>;
type PostSchemas = CombinedPaths<
  FilterByFetchType<appPaths & sharedPaths, PostRequest>
>;
type PostPaths = keyof PostSchemas;
type GetPaths = keyof GetSchemas;

export const useBillingAPI = <
  PATH extends GetPaths,
  ResponseData = GetSchemas[PATH]["get"]["responses"][200]["content"]["application/json"],
>(
  path: PATH | null,
  query?: QueryParams,
  options?: SWRConfiguration
) => {
  return useAPI<ResponseData>(path, query, options);
};

export type InferBillingAPI<
  PATH extends GetPaths,
  Options extends InferAPIOptions = "data",
> = InferAPI<typeof useBillingAPI<PATH>, Options>;

export const useBillingSubmit = <PATH extends PostPaths>(
  path: PATH,
  options?: UseSubmitOptions<ExtractPostResponseData<PostSchemas, PATH>>
) => {
  return useSubmit<
    ExtractPostResponseData<PostSchemas, PATH>,
    ExtractPostRequestBody<PostSchemas, PATH>
  >(path, options || {});
};
